interface IProps {
    size?: number;
    color?: string;
}

export const IconCheck3 = (props: IProps) => {
    const { size, color } = props;
    const defaultSize = "14";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size || defaultSize}
            height={size || defaultSize}
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M4.30941 10.6647C3.81816 10.1128 3.42134 9.57297 3.03802 9.05013C2.68775 8.57473 2.38403 8.06672 2.13108 7.53313C1.97275 7.20937 1.90268 6.88154 2.24562 6.67076C3.22845 6.06676 3.42986 6.64348 3.96406 7.31264C4.2807 7.70916 4.74763 8.36301 5.04019 8.77613C5.31965 9.17064 5.66033 8.4586 5.79633 8.25768C6.27972 7.54364 7.53606 5.79554 8.05523 5.14937C8.54811 4.53595 10.139 2.81748 10.4356 2.54415C10.688 2.31142 11.221 1.80094 11.5794 2.08255C11.956 2.37843 12.14 2.94087 11.8753 3.30658C11.4142 3.94325 10.69 4.5489 10.1889 5.15513C9.17453 6.38227 8.21418 7.70503 7.29234 9.02208C6.97909 9.46964 6.53929 10.2192 6.26625 10.7046C5.75548 11.6127 5.30685 11.7855 4.30941 10.6647Z"
                fill={color || "#5B835D"}
            />
        </svg>
    );
};
